import { render } from "./CoinPaymentSuccess.vue?vue&type=template&id=40f05bfe&scoped=true"
import script from "./CoinPaymentSuccess.vue?vue&type=script&lang=js"
export * from "./CoinPaymentSuccess.vue?vue&type=script&lang=js"

import "./CoinPaymentSuccess.vue?vue&type=style&index=0&id=40f05bfe&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1919945302/src/app.tamildata.org/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40f05bfe"]])

export default __exports__